import React from "react";

const passos = [
  {
    titulo: "Cadastre a fazenda",
    texto:
      "Nome, inscrição, cidade e roteiro de entrega. Dá para colar a localização que veio pelo WhatsApp e conferir no mapa.",
  },
  {
    titulo: "Navegue pelo catálogo",
    texto:
      "Por segmento, por parceiro ou pela busca. Cada produto já mostra o preço de cada embalagem, o mínimo e o frete.",
  },
  {
    titulo: "Monte o carrinho",
    texto:
      "Escolha a embalagem e a modalidade de frete, CIF ou FOB. O total sai na hora, sem esperar ninguém responder.",
  },
  {
    titulo: "Pague no app",
    texto:
      "PIX, boleto ou cartão, parcelado quando o parceiro permite. O comprovante fica guardado no pedido.",
  },
  {
    titulo: "Acompanhe até a fazenda",
    texto:
      "Aprovado, itens em separação, a caminho, entregue. Cada etapa aparece na sua tela no instante em que muda.",
  },
];

const ComoFunciona: React.FC = () => (
  <section className="border-b border-bone-300 bg-white">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <div className="max-w-2xl">
        <p className="eyebrow">Da busca à entrega</p>
        <h2 className="mt-4 font-display text-display-md font-bold text-soil">
          Como funciona
        </h2>
      </div>

      <ol className="mt-12 grid gap-px border border-bone-300 bg-bone-300 sm:grid-cols-2 lg:grid-cols-3">
        {passos.map((p, i) => (
          <li key={p.titulo} className="bg-white p-6 lg:p-7">
            <div className="flex items-baseline gap-3">
              <span className="num text-sm font-semibold text-soy-dark">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="h-px flex-1 bg-bone-300" aria-hidden="true" />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-soil">
              {p.titulo}
            </h3>
            <p className="mt-2.5 text-sm leading-relaxed text-soil/70">{p.texto}</p>
          </li>
        ))}

        <li className="bg-bone/70 p-6 lg:p-7">
          <div className="flex items-baseline gap-3">
            <span className="font-mono text-[0.6875rem] uppercase tracking-[0.14em] text-soil/40">
              exceção
            </span>
            <span className="h-px flex-1 bg-bone-300" aria-hidden="true" />
          </div>
          <h3 className="mt-4 font-display text-lg font-bold text-soil">
            Não achou o produto?
          </h3>
          <p className="mt-2.5 text-sm leading-relaxed text-soil/70">
            Só nesse caso você abre uma cotação. O pedido vai para os parceiros da
            sua região e eles respondem com preço e prazo.
          </p>
        </li>
      </ol>
    </div>
  </section>
);

export default ComoFunciona;
